import UserAvatar from 'src/components/user_avatar/user_avatar.vue'

import { useUsersStore } from 'src/stores/users.js'

import { profileLink } from 'src/services/user_display/user_display.js'

const AvatarList = {
  props: {
    userIds: Set,
  },
  computed: {
    slicedUsers() {
      return [...(this.userIds ?? [])]
        .slice(0, 15)
        .map((id) => useUsersStore().findUser(id))
    },
  },
  components: {
    UserAvatar,
  },
  methods: {
    userProfileLink: profileLink,
  },
}

export default AvatarList
